import { defineBlock, smartProps, useInspectorControl } from '@smartfire/js-block-engine';
import { EditableImg, EditableHeading } from '@smartfire/components';
import React from 'react';
import Button from '../../button/block';

import style from './block.module.scss';

const Inspector = React.lazy(() => import('./InspectorControl'));

function ActiviteTool({ linkButton, textButton }) {
    useInspectorControl(Inspector);

    return (
        <div className={style.block}>
            <EditableImg smartProp={'image'} className={style.img} />
            <EditableHeading smartProp={'title'} placeholder={'Insérez le titre'} className={style.title} />
            <Button link={linkButton} text={textButton} aspect="ghost" styleGhost="style-1" inspector={false} />
        </div>
    );
}

export default defineBlock({
    Block: ActiviteTool,
    smartProps: {
        image: smartProps.image,
        title: smartProps.object.withDefault({
            headingLevel: 3,
            content: '',
        }),
        linkButton: smartProps.string.withDefault(''),
        textButton: smartProps.string.withDefault('En savoir plus'),
    },
    setup: {
        title: 'Activité Tile',
        parent: ['smartfire/activites-list'],
    },
});
